import { StyledCheckBox, StyledSheetDiv } from '../../../../shared/styles/components/integrations.styles';
import { StyledTd, StyledTh } from '../../../../shared/styles/components/table.styles';
import { Table, TableBody, TableHead } from '@mui/material';

import { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { Item } from '../../types/item.types';
import { thousandSeparator } from '../../../../shared/utils/formatters.utils';

interface ItemEditingSectionProps {
    parentItemClone: Item;
    control: Control<any>;
}

export const ItemEditingSection = ({ parentItemClone, control }: ItemEditingSectionProps) => {
    return (
        <>
            <Table>
                <TableHead>
                    <tr>
                        <StyledTh>Included</StyledTh>
                        <StyledTh>Supplier</StyledTh>
                        <StyledTh>Net weight (g)</StyledTh>
                    </tr>
                </TableHead>
                <TableBody>
                    {parentItemClone.dwpActCpInfo?.suppliers.map((column) => (
                        <tr key={column.buCode}>
                            <StyledTd>
                                <Controller
                                    control={control}
                                    name={column.buCode}
                                    render={({ field: { onChange, onBlur } }) => (
                                        <StyledSheetDiv style={{ justifyContent: 'space-between', display: 'flex' }}>
                                            <StyledCheckBox
                                                onBlur={onBlur}
                                                disabled
                                                onChange={(e) => {
                                                    column.included = e.target.checked;
                                                    onChange(e);
                                                }}
                                                id={column.buCode}
                                                value={column.buCode}
                                                checked={column.included}
                                            />
                                        </StyledSheetDiv>
                                    )}
                                />
                            </StyledTd>
                            <StyledTd>{column.buCode}</StyledTd>
                            <StyledTd>
                                {column.cpTotWeiNet && thousandSeparator(Math.round(column.cpTotWeiNet * 1000))}
                            </StyledTd>
                        </tr>
                    ))}
                </TableBody>
            </Table>
            {parentItemClone.isDwpDeviationWarningHidable && (
                <div style={{ marginTop: '2em' }}>
                    <Controller
                        control={control}
                        name="dwpWarningEnabled"
                        render={({ field: { onBlur, onChange, value } }) => (
                            <StyledSheetDiv style={{ justifyContent: 'space-between', display: 'flex' }}>
                                <StyledCheckBox
                                    onBlur={onBlur}
                                    onChange={(e) => {
                                        e.target.checked = !e.target.checked;
                                        parentItemClone.dwpWarningEnabled = e.target.checked;
                                        onChange(e);
                                    }}
                                    id="dwpWarnEnabled"
                                    value="dwpWarnEnabled"
                                    label="Accept weight deviation"
                                    checked={!value}
                                />
                            </StyledSheetDiv>
                        )}
                    />
                </div>
            )}
        </>
    );
};